import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import colors from "assets/theme/base/colors";
import "react-toastify/dist/ReactToastify.css";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import "../campus/Campus.css";
import { hasAdmissionPermission } from "hooks/permissions";
const { info } = colors;

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const Quota = () => {
  // State variables
  const [quotas, setQuotas] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [showAddQuotaModal, setShowAddQuotaModal] = useState(false);
  const [showUpdateQuotaModal, setShowUpdateQuotaModal] = useState(false);
  const [showDeleteQuotaModal, setShowDeleteQuotaModal] = useState(false);
  const [currentQuotaId, setCurrentQuotaId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [formErrors, setFormErrors] = useState({ name: "", description: "" });
  const [showViewQuotaModal, setShowViewQuotaModal] = useState(false);
  const [selectedQuota, setSelectedQuota] = useState(null);

  const [isUpdating, setIsUpdating] = useState(false);
  // Dummy data for quotas
  const dummyData = [
    { id: 1, name: "Quota A", description: "Description for Quota A" },
    { id: 2, name: "Quota B", description: "Description for Quota B" },
    { id: 3, name: "Quota C", description: "Description for Quota C" },
    { id: 4, name: "Quota D", description: "Description for Quota D" },
    { id: 5, name: "Quota E", description: "Description for Quota E" },
  ];

  const getQuotas = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(`${BASE_URL}/quota/get_quotas`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setQuotas(data.quotas);
      })
      .catch((error) => console.log(error));
    // setDQquotas(dummyData);
  };

  // Add quota
  const addQuota = async () => {
    const data = { name, description };
    try {
      const response = await fetch(`${BASE_URL}/quota/create_qouta`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to add quota");
      }

      const newQuota = await response.json();
      setQuotas([...quotas, newQuota]);
      getQuotas();
      toast.success("Quota added successfully");
      resetForm();
    } catch (error) {
      toast.error("Failed to add quota");
    } finally {
      setShowAddQuotaModal(false);
    }
  };

  const deleteQuota = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/quota/delete_quota/${currentQuotaId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete quota");
      }

      setQuotas(quotas.filter((quota) => quota.id !== currentQuotaId));
      toast.success("Quota deleted successfully");
    } catch (error) {
      console.error("Error deleting quota:", error);
      toast.error("Failed to delete quota");
    } finally {
      setShowDeleteQuotaModal(false);
    }
  };

  // Update quota
  const updateQuota = async () => {
    const data = { id: currentQuotaId, name, description };
    try {
      const response = await fetch(`${BASE_URL}/quota/update_quota`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to update quota");
      }

      const updatedQuota = await response.json();

      toast.success("Quota updated successfully");
    } catch (error) {
      console.error("Error updating quota:", error);
      toast.error("Failed to update quota");
    } finally {
      getQuotas();
      setShowUpdateQuotaModal(false);
      resetForm();
    }
    // setIsUpdating(true);
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  const resetForm = () => {
    setName("");
    setDescription("");
    setFormErrors({ name: "", description: "" });
  };

  // Search functionality
  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getQuotas();
    } else {
      const filteredQuotas = quotas.filter((quota) => {
        return (
          quota.name.toLowerCase().includes(searchTerm) ||
          quota.description.toLowerCase().includes(searchTerm)
        );
      });
      setQuotas(filteredQuotas);
    }
  };

  const callErrors = (NAME, DESCRIPTION) => {
    const errors = {};
    if (NAME === "") {
      errors.name = " *Name is Required";
    }
    if (DESCRIPTION === "") {
      errors.description = " * Description is Required";
    }

    setFormErrors(errors);
  };

  const handleCancelAddQuotaModal = () => {
    setShowAddQuotaModal(false);
    setDescription("");
    setName("");
    setFormErrors({
      name: "",
      description: "",
    });
  };

  const handleOkAddQuotaModal = () => {
    if (name && description) {
      addQuota();
      setShowAddQuotaModal(false);
    } else {
      callErrors(name, description);
    }
  };

  // Dialog handlers
  const showQuotaAddModal = () => {
    resetForm();
    setShowAddQuotaModal(true);
  };

  const showQuotaUpdateModal = (id) => {
    setCurrentQuotaId(id);
    const quota = quotas.find((q) => q.id === id);
    setName(quota.name);
    setDescription(quota.description);
    setShowUpdateQuotaModal(true);
  };

  const showQuotaDeleteModal = (id) => {
    setCurrentQuotaId(id);
    setShowDeleteQuotaModal(true);
  };

  const viewQuota = (id) => {
    const quota = quotas.find((q) => q.id === id);
    setSelectedQuota(quota);
    setShowViewQuotaModal(true);
  };

  // Initial render
  useEffect(() => {
    getQuotas();
  }, [isUpdating]);

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Quota Name", accessor: "quota_name", align: "center" },
    { Header: "Description", accessor: "description", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows = quotas.map((quota, index) => ({
    serial: index + 1,
    quota_name: quota.name,
    description: quota.description,
    actions: (
      <>
        {hasAdmissionPermission("Quota", "UPDATE") && (
        <IconButton onClick={() => showQuotaUpdateModal(quota.id)}>
          <EditIcon className="icon-button-edit" />
        </IconButton>
        )}
        {hasAdmissionPermission("Quota", "READ") && (
        <IconButton onClick={() => viewQuota(quota.id)}>
          <VisibilityOutlinedIcon className="icon-button-view" />
        </IconButton>
        )}
        {hasAdmissionPermission("Quota", "DELETE") && (
        <IconButton onClick={() => showQuotaDeleteModal(quota.id)}>
          <DeleteIcon className="icon-button-delete" />
        </IconButton>
        )}
      </>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Paper className="search-paper" component="form">
                  <InputBase
                    sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "search voucher" }}
                    value={searchKeyword}
                    onChange={handleSearchKeywordChange}
                  />
                  <SearchIcon className="search-icon" />
                </Paper>
                {hasAdmissionPermission("Quota", "CREATE") && (
                <Button
                  className="add-button"
                  variant="filled"
                  endIcon={<AddIcon className="add-icon" />}
                  onClick={showQuotaAddModal}
                  color="info.main"
                >
                  Add
                </Button>
                )}
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add Quota Dialog */}
      <Dialog
        open={showAddQuotaModal}
        onClose={handleCancelAddQuotaModal}
        maxWidth="lg"
        // fullWidth
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          Add Quota
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6 left-fields">
              <div className="form-outline mt-3">
                <label>Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Name"
                />
              </div>
              <div className="error-message1">{formErrors.name}</div>
            </div>
            <div className="col-md-6 mt-3 form-sideline">
              <label>Description</label>
              <input
                placeholder="Description"
                name="address"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                onFocus={handleFocus}
                className="form-control form-control-lg"
              />
              <div className="error-message">{formErrors.description}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelAddQuotaModal}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkAddQuotaModal}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Quota Dialog */}
      <Dialog
        open={showUpdateQuotaModal}
        onClose={() => setShowUpdateQuotaModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          Update Quota
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Name</label>
                <input
                  placeholder="Quota Name"
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.name}</div>
            </div>

            <div className="col-md-6 mt-3">
              <label>Description</label>
              <input
                placeholder="Description"
                name="address"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-control form-control-lg"
              />
              <div className="error-message">{formErrors.description}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowUpdateQuotaModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={updateQuota}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Quota Dialog */}
      <Dialog
        open={showDeleteQuotaModal}
        onClose={() => setShowDeleteQuotaModal(false)}
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle className="dialog-delete">Delete Quota</DialogTitle>
        <DialogContent className="content-delete">
          Are you sure you want to delete this quota?
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowDeleteQuotaModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={deleteQuota}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Quota Dialog */}
      <Dialog
        open={showViewQuotaModal}
        onClose={() => setShowViewQuotaModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          View Quota
        </DialogTitle>
        <DialogContent className="dialog-content">
          {selectedQuota && (
            <>
              <div className="flex-container">
                <strong className="label1">Name</strong>
                <span className="value1">{selectedQuota.name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Description</strong>
                <span className="value1">{selectedQuota.description}</span>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowViewQuotaModal(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default Quota;
